import '../App.css';
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from 'axios';
import { useEffect, useState } from 'react';
import ChartImpressions from '../ChartImpressions';
import ChartScreenTime from '../ChartScreenTime';
import CampaignStatsTopDevices from './CampaignStatsTopDevices';
import V2Card from '../V2Card';

function CampaignStats({ campaign_id }) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [impressionsCount, setImpressionsCount] = useState(null);
    const [screenTimeTotal, setScreenTimeTotal] = useState(null);

    function getImpressionsCount(campaign_id) {
        axios.get(
            process.env.REACT_APP_API_HOST + `/stats/impressions/count/?campaign_id=${campaign_id}`
        ).then(
            (response) => {
                setImpressionsCount(response.data.count);
            }
        ).catch(
            (error) => navigate('/')
        )
    }

    function getScreenTimeTotal(campaign_id) {
        axios.get(
            process.env.REACT_APP_API_HOST + `/stats/screen_time/?campaign_id=${campaign_id}`
        ).then(
            (response) => {
                setScreenTimeTotal(response.data.sum);
            }
        ).catch(
            (error) => navigate('/')
        )
    }

    function prettyTime(t) {
        if (!t) {
            return 0;
        }

        if (t < 60) {
            return `${t.toFixed(1)} seconds`;
        }
        if (t < 60 * 60) {
            return `${(t / 60).toFixed(1)} minutes`;
        }
        return `${(t / (60 * 60)).toFixed(1)} hours`;
    }

    useEffect(
        () => {
            getImpressionsCount(campaign_id);
            getScreenTimeTotal(campaign_id);
        },
        [],
    )

    return (
        <div align='center'>
            <V2Card>
                <div
                    align='left'
                >
                    <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                        <div style={{ marginRight: '4em' }}>
                            <div>
                                Impressions
                            </div>
                            <h2>
                                {impressionsCount}
                            </h2>
                        </div>
                        <div>
                            <div>
                                Screen Time
                            </div>
                            <h2>
                                {prettyTime(screenTimeTotal)}
                            </h2>
                        </div>
                    </div>
                </div>
            </V2Card>
            <V2Card>
                <div
                    align='left'
                >
                    <ChartImpressions
                        campaign_id={campaign_id}
                    />
                </div>
            </V2Card>
            <V2Card>
                <div
                    align='left'
                >
                    <ChartScreenTime
                        campaign_id={campaign_id}
                    />
                </div>
            </V2Card>
            <V2Card>
                <CampaignStatsTopDevices
                    campaign_id={campaign_id}
                />
            </V2Card>
        </div>
    );
}

export default CampaignStats;